import { gql } from "@apollo/client";

export const GET_PERSON = gql`
  query GET_PERSON($personId: ID!, $originatorId: ID!) {
    getPerson(personId: $personId, originatorId: $originatorId) {
      aliases {
        id
        target {
          id
          validPersonAlerts {
            alertType {
              name
              alertLevel
            }
          }
        }
      }
      id
      aliases {
        id
        description
        createdAt
        updatedAt
        target {
          aliases {
            id
            target {
              id
              validPersonAlerts {
                alertType {
                  name
                  alertLevel
                }
              }
            }
          }
          validPersonAlerts {
            alertType {
              name
              alertLevel
            }
          }
          id
          personalAttribute {
            dob
            firstName
            homeAddress {
              id
              city
              lat
              lng
              name
              state
              streetName
              streetNumber
              unit
              zip
              validAddressAlerts {
                alertType {
                  id
                  name
                  alertLevel
                  oriId
                  position
                }
                expireAt
                id
                notes
                officer {
                  id
                }
              }
            }
            mailingAddress {
              id
              city
              lat
              lng
              name
              state
              streetName
              streetNumber
              unit
              zip
            }
            id
            lastName
            middleName
            organization
            phone
            cell
            suffix
            driversLicense
            fishWildlifeLicense
            licenseState {
              id
              name
              oriId
              position
            }
          }
        }
      }
      groups {
        id
        oriId
        name
        position
      }
      photos {
        id
        confidential
        dataFileName
        dataUrl
        unencryptedDataUrlWrapper
        dataUrlWrapper
        description
      }
      genericAttachments {
        attachmentType {
          id
          name
        }
        confidential
        dataFileName
        dataUrl
        dataUrlWrapper
        description
        incident {
          id
          ori {
            id
          }
        }
        employee {
          id
          personalAttribute {
            lastName
            firstName
          }
          deptAttribute {
            badge
            ori {
              id
              abbreviation
            }
          }
        }
        id
        lastUpdated
        ownerName
      }
      validPersonAlerts {
        alertType {
          id
          name
          alertLevel
          oriId
          position
        }
        expireAt
        id
        notes
        officerId
        createdAt
        officer {
          deptAttribute {
            id
            badge
            ori {
              id
              abbreviation
            }
          }
          personalAttribute {
            id
            firstName
            lastName
          }
        }
        person {
          id
        }
      }
      personalAttribute {
        aliasName
        bilingual
        buildType {
          id
          name
          oriId
          position
        }
        cell
        deceased
        distinguishingCharacteristics
        dob
        driversLicense
        email
        employer
        employerAddress {
          id
          city
          id
          lat
          lng
          name
          state
          streetName
          streetNumber
          unit
          validAddressAlerts {
            alertType {
              id
              name
              alertLevel
              oriId
              position
            }
            expireAt
            id
            notes
            createdAt
            officer {
              deptAttribute {
                id
                badge
                ori {
                  id
                  abbreviation
                }
              }
              personalAttribute {
                id
                firstName
                lastName
              }
            }
          }
          zip
        }
        eyeColor {
          id
          name
          oriId
          position
        }
        facialHairType {
          id
          name
          oriId
          position
        }
        fbiNumber
        firstName
        fishWildlifeLicense
        gangAffiliateds {
          id
          name
          oriId
          position
        }
        gender {
          id
          name
          oriId
          position
        }
        hairColor {
          id
          name
          oriId
          position
        }
        hairLength {
          id
          name
          oriId
          position
        }
        height
        homeAddress {
          id
          city
          id
          lat
          lng
          name
          state
          streetName
          streetNumber
          unit
          validAddressAlerts {
            alertType {
              id
              name
              alertLevel
              oriId
              position
            }
            expireAt
            id
            notes
            createdAt
            officer {
              deptAttribute {
                id
                badge
                ori {
                  id
                  abbreviation
                }
              }
              personalAttribute {
                id
                firstName
                lastName
              }
            }
          }
          zip
        }
        ibrArresteeRaceType {
          id
          name
          oriId
          position
        }
        id
        juvenile
        lastName
        licenseState {
          id
          name
          oriId
          position
        }
        mailingAddress {
          id
          city
          id
          lat
          lng
          name
          state
          streetName
          streetNumber
          unit
          validAddressAlerts {
            alertType {
              id
              name
              alertLevel
              oriId
              position
            }
            expireAt
            id
            notes
            createdAt
            officer {
              deptAttribute {
                id
                badge
                ori {
                  id
                  abbreviation
                }
              }
              personalAttribute {
                id
                firstName
                lastName
              }
            }
          }
          zip
        }
        mentalHealthAlert
        middleName
        nibrsGender {
          id
          name
          oriId
          position
        }
        notes
        organization
        phone
        pobAddress {
          id
          city
          id
          lat
          lng
          name
          state
          streetName
          streetNumber
          unit
          validAddressAlerts {
            alertType {
              id
              name
              alertLevel
              oriId
              position
            }
            expireAt
            id
            notes
            createdAt
            officer {
              deptAttribute {
                id
                badge
                ori {
                  id
                  abbreviation
                }
              }
              personalAttribute {
                id
                firstName
                lastName
              }
            }
          }
          zip
        }
        race {
          id
          name
          oriId
          position
        }
        residentType {
          id
          name
          oriId
          position
        }
        school
        sid
        substanceAbuseAlert
        suffix
        violenceAlert
        waiverFine
        weaponsAlert
        weight
        work
      }
    }
  }
`;
